import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    params: {
      placementFromConfigure:'default'
    },
    currencyCode: 'USD',
    localeIdentifier: 'en-US',
    configLine:'',
    content:{
      "turnYourPhoneIntoPortableScanner" : `Turn your phone<br> into portable<br> Scanner`,
      "easyToUse" : "Easy-to-use mobile scanner for scanning all documents, business cards, receipts, images & drafts.",
      "next" : "Next",
      "signFaxStore" : "Sign, Fax<br> and Store docs",
      "editYourDocuments" : "Edit your documents: crop, add personal or corporate stamp. Send faxes and use cloud storage.",
      "businessPackSlideHeading" : "Business Pack:<br> Scanner + Phone Number",
      "useBothApp" : "Use both Scanner and Second Phone Number apps for one subscription.",
      "unlockBusinessPack" : "Unlock<br> Business Pack!",
      "unlimitedScanning" : "Unlimited scanning",
      "signStampFeature" : "Stamp & Sign feature",
      "faxes20" : "20 faxes weekly",
      "faxes20cloud200" : "20 faxes weekly & 200Gb cloud",
      "cloud50" : "Get 50Gb Cloud Storage",
      "spn" : "Second phone number",
      "orContinue" : "or continue with a limited version",
      "months" : "months",
      "week" : "week",
      "alreadyHaveAccoutn" : "Already have an account?",
      "subscribeWithTrial" : "SUBSCRIBE WITH<br>  3 DAYS TRIAL",
      "viewAllPlans" : "View all plans",
      "landingEula" : `Payment will be charged to your Apple ID account at the confirmation of
      purchase. The subscription automatically renews unless it is canceled at
      least 24 hours before the end of the current period. Your account will be
      charged for renewal within 24 hours prior to the end of the current
      period. You can manage and cancel your subscriptions by going to your App
      Store account settings after purchase. Any unused portion of a free trial
      period, if offered, will be forfeited when the user purchases a
      subscription to that publication, where applicable.`,
      "allPlans" : "All plans",
      "basic" : "Basic",
      "businessPack" : "Business Pack",
      "3daysTrial" : "3 days trial",
      "20faxes" : "20 faxes",
      "200cloud" : "200 Gb cloud",
      "50cloud" : "50Gb cloud",
      "perYear" : "per year",
      "perWeek" : "per week",
      "per6months" : "per 6 months",
      "privacy" : "Privacy policy",
      "restore" : "Restore",
      "tos" : "Terms of use",
      "get200gbCloud" : "Get 200Gb Cloud Storage",
      "unlockAllFeatures" : "Unlock all features!"
   },
    subscriptions: [
      {
        devName: "com.neosus.scannerfree.1weekspo",
        price: "$9.99",
        name: "1 Week Pack",
        text: "3 days trial",
        priceNumber: "9.99",
        trial: "3",
        period: "week",
        link: "",
        businessPack:true
      },
      {
        devName: "com.neosus.scannerfree.5",
        price: "$24.99",
        name: "1 Month Pack",
        text: "3 days trial",
        priceNumber: "2.99",
        trial: "3",
        period: "month",
        link: "",
        businessPack:true
      },
      {
        devName: "com.neosus.scannerfree.2",
        price: "$69.99",
        name: "6 Months Pack",
        text: "3 days trial",
        priceNumber: "34.99",
        trial: "3",
        period: "6 months",
        link: "",
        businessPack:true
      },
      {
        devName: "com.neosus.scannerfree.1",
        price: "$119.99",
        name: "12 Months Pack",
        text: "3 days trial",
        priceNumber: "119.99",
        trial: "3",
        period: "year",
        link: "",
        businessPack:true
      },
      {
        devName: "com.neosus.scannerfree.4",
        price: "$9.99",
        name: "1 Week",
        text: "7 days trial, 20 faxes, 200Gb cloud",
        priceNumber: "9.99",
        trial: "7",
        period: "week",
        link: ""
      },
      {
        devName: "com.neosus.scannerfree.6months",
        price: "$34.99",
        name: "6 Months",
        text: "7 days trial, 50Gb cloud",
        priceNumber: "34.99",
        trial: "7",
        period: "6 months",
        link: ""
      },
      {
        devName: "com.neosus.scannerfree.1year",
        price: "$49.99",
        name: "12 Months",
        text: "7 days trial, 50Gb cloud",
        priceNumber: "49.99",
        trial: "7",
        period: "year",
        link: ""
      }
    ],
    initialBg:{
      'backgroundColor':'#0a0a27'
    }
  },
  mutations: {
    SET_CONTENT(state, content) {
      state.content = content;
    },
    SET_SUBSCRIPTIONS(state, config) {
      state.subscriptions = config.subscriptions;
      state.currencyCode = config.currencyCode
      state.localeIdentifier = config.localeIdentifier
    },
    SET_PARAMS(state, params) {
      state.params = params;
    },
    CHANGE_BG(state, color){
      state.initialBg = {'backgroundColor':color};
    },
    SET_CONFIG_LINE(state, config){
      state.configLine = config;
    },
  },
  actions: {
    setConfigLine(context, config) {
      context.commit("SET_CONFIG_LINE", config);
    },
    setContent(context, content) {
      context.commit("SET_CONTENT", content);
    },
    setSubscriptions(context, config) {
      context.commit("SET_SUBSCRIPTIONS", config);
    },
    setParams(context, params) {
      context.commit("SET_PARAMS", params);
    },
    changeBg (context, color){
      context.commit("CHANGE_BG", color);
    }
  }
});
